import {React} from 'external/react'
import {styled, MenuItem} from 'external/material'
import ClearableSelect from 'components/clearable-select'
import {EDITIONS, resolveEdition} from '../domain/editions.cjs'

const Root = styled('div')({display:'flex', flexDirection:'column', width:'100%', minWidth:0, '& .MuiFormControl-root':{width:'100%', minWidth:0}})

// Controlled and context-free: callers own navigation and state updates.
export default function EditionSelect ({value, onChange}) {
  return <Root>
    <ClearableSelect id="standard-edition-filter" caption="Edición" value={resolveEdition(value)} onChange={event => onChange(event.target.value)} onClear={() => onChange(undefined)}>
      {EDITIONS.map(({id, year}) => <MenuItem key={id} value={id}>{year}</MenuItem>)}
    </ClearableSelect>
  </Root>
}
